/**
 * @generated SignedSource<<5b6056c3826868b421612bb821763d07>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type EditJiraEpicsInput = {
  jiraEpicIds?: ReadonlyArray<string | null> | null;
  forecastProjectId?: string | null;
  csrfToken?: string | null;
  socketClientId?: string | null;
  clientMutationId?: string | null;
};
export type EditJiraEpicsMutation$variables = {
  input: EditJiraEpicsInput;
};
export type EditJiraEpicsMutation$data = {
  readonly editJiraEpics: {
    readonly project: {
      readonly id: string;
      readonly isJiraProject: boolean | null;
      readonly jiraCloudEpicIds: ReadonlyArray<string | null> | null;
      readonly jiraCloudProjectSettings: {
        readonly isSyncDone: boolean | null;
      } | null;
    } | null;
    readonly errors: ReadonlyArray<string | null> | null;
  } | null;
};
export type EditJiraEpicsMutation = {
  variables: EditJiraEpicsMutation$variables;
  response: EditJiraEpicsMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isJiraProject",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "jiraCloudEpicIds",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isSyncDone",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "errors",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "EditJiraEpicsMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "EditJiraEpicsPayload",
        "kind": "LinkedField",
        "name": "editJiraEpics",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "ProjectType",
            "kind": "LinkedField",
            "name": "project",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              (v4/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "JiraCloudProjectSettingsType",
                "kind": "LinkedField",
                "name": "jiraCloudProjectSettings",
                "plural": false,
                "selections": [
                  (v5/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v6/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "EditJiraEpicsMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "EditJiraEpicsPayload",
        "kind": "LinkedField",
        "name": "editJiraEpics",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "ProjectType",
            "kind": "LinkedField",
            "name": "project",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              (v4/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "JiraCloudProjectSettingsType",
                "kind": "LinkedField",
                "name": "jiraCloudProjectSettings",
                "plural": false,
                "selections": [
                  (v5/*: any*/),
                  (v2/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v6/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "167509a0a28befe7d918e02d25b05aeb",
    "id": null,
    "metadata": {},
    "name": "EditJiraEpicsMutation",
    "operationKind": "mutation",
    "text": "mutation EditJiraEpicsMutation(\n  $input: EditJiraEpicsInput!\n) {\n  editJiraEpics(input: $input) {\n    project {\n      id\n      isJiraProject\n      jiraCloudEpicIds\n      jiraCloudProjectSettings {\n        isSyncDone\n        id\n      }\n    }\n    errors\n  }\n}\n"
  }
};
})();

(node as any).hash = "1bb44febdffed2b83849b7fb4cc7a4f8";

export default node;
